import { EntityLayout } from '@backstage/plugin-catalog';
import { OverviewContent, TechDocsContent } from '../../components/entity-content';

export const DefaultEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {OverviewContent}
    </EntityLayout.Route>

    <EntityLayout.Route path="/docs" title="Docs">
      {TechDocsContent}
    </EntityLayout.Route>
  </EntityLayout>
);
